import { useQuery } from '@apollo/client';
import { GET_COLLECTIONS_LIST } from '../api';
import { GetCollectionsListQuery } from '../api/types';
import { COLLECTIONS_CHUNK_SIZE } from '@/constants/common';

export const useCollectionsList = () => {
  const { data, loading, refetch, fetchMore } =
    useQuery<GetCollectionsListQuery>(GET_COLLECTIONS_LIST, {
      fetchPolicy: 'network-only',
      variables: {
        first: COLLECTIONS_CHUNK_SIZE,
      },
    });

  return {
    loading,
    refetch,
    fetchMore,
    collections: data?.currentUser?.bookmarkCollections?.nodes ?? [],
    endCursor: data?.currentUser?.bookmarkCollections?.pageInfo?.endCursor,
    hasNextPage: data?.currentUser?.bookmarkCollections?.pageInfo?.hasNextPage,
  };
};
